import React from "react";

const Ratings = () => {
  return <div>Ratings</div>;
};

export default Ratings;
